export default __webpack_public_path__ + "static/media/knob-emoji.5e6151d0.png";